import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="public-dropdown"
// Generic dropdown toggle for the public header user menu (avatar + menu).
// Closes on click outside and on Escape. Mirrors admin-dropdown but kept
// independent so the public area carries no dependency on the admin layer.
export default class extends Controller {
  static targets = ["menu", "button", "icon"]
  static values = {
    open: { type: Boolean, default: false }
  }

  connect() {
    this.closeOnClickOutside = this.closeOnClickOutside.bind(this)
    this.closeOnEscape = this.closeOnEscape.bind(this)
  }

  disconnect() {
    this.removeEventListeners()
  }

  toggle(event) {
    event.preventDefault()
    this.openValue = !this.openValue
    this.updateState()
  }

  close() {
    this.openValue = false
    this.updateState()
  }

  updateState() {
    if (this.openValue) {
      this.open()
    } else {
      this.closeMenu()
    }
  }

  open() {
    if (this.hasMenuTarget) {
      this.menuTarget.hidden = false
    }

    if (this.hasButtonTarget) {
      this.buttonTarget.setAttribute("aria-expanded", "true")
    }

    if (this.hasIconTarget) {
      this.iconTarget.classList.add("rotate-180")
    }

    this.addEventListeners()
  }

  closeMenu() {
    if (this.hasMenuTarget) {
      this.menuTarget.hidden = true
    }

    if (this.hasButtonTarget) {
      this.buttonTarget.setAttribute("aria-expanded", "false")
    }

    if (this.hasIconTarget) {
      this.iconTarget.classList.remove("rotate-180")
    }

    this.removeEventListeners()
  }

  addEventListeners() {
    document.addEventListener("click", this.closeOnClickOutside)
    document.addEventListener("keydown", this.closeOnEscape)
  }

  removeEventListeners() {
    document.removeEventListener("click", this.closeOnClickOutside)
    document.removeEventListener("keydown", this.closeOnEscape)
  }

  closeOnClickOutside(event) {
    if (!this.element.contains(event.target)) {
      this.close()
    }
  }

  closeOnEscape(event) {
    if (event.key === "Escape") {
      this.close()
    }
  }

  openValueChanged() {
    this.updateState()
  }
}
